import PropTypes from "prop-types";
import styles from "./CTAButton.module.scss";
import { Link } from "../DependencyHelper";
import { isExternalUrl, internalUrl } from "../../../utils/helperServices";
import config from "../../../config/index";
/**
 * CTAButton component: Displays button based on props passed from parent component.
 * e.g <CTAButton variant="primary" id="" className=""/>
 */

// * For proper styling, use one of the among variants.
const VARIANTS = [
  "primary",
  "solid white",
  "solid grey",
  "solid blackish",
  "solid black",
  "solid red",
  "solid green",
  "outline black",
  "outline white",
  "outline grey",
  "flat black",
  "flat white",
  "flat red",
  "flat teal51",
  "link teal",
  "link black",
  "link white",
  "link teal51",
  "solid light gray"
];
const CTAButton = props => {
  const variant = props.variant.toLowerCase();
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  // checks if props button variant type exists in our VARIANTS stylings
  const setButtonStyle = VARIANTS.includes(variant)
    ? variant.replace(/ /g, "-")
    : VARIANTS[0];

  const ctaLink = internalUrl(props.url);

  const generateImageUrl = () => {
    switch (props.variant) {
      case "link teal51":
        return `${imagePrefix}/assets/images/custom-arrow-teal.svg`;
      case "link white":
        return `${imagePrefix}/assets/images/custom-arrow-white.svg`;
      default:
        return `${imagePrefix}/assets/images/custom-arrow.svg`;
        break;
    }
  };

  const renderButtonContents = () => {
    if (props.url) {
      return (
        <>
          <Link legacyBehavior
            href={ctaLink.url}
            prefetch={
              props.isOpenNewTab && props.isOpenNewTab === "1"
                ? false
                : ctaLink.internal
            }
            passHref
          >
            <a
              id={props.id}
              onClick={props.handleClick}
              className={`${styles["button"]} ${
                styles[`button__${setButtonStyle}`]
              } ${props.className} ${styles[props?.btnSizing]}`}
              target={props.isOpenNewTab === "1" ? "_blank" : "_self"}
            >
              {props.children}
              {props.variant.includes("link") ? (
                <span className={styles["right-arrow"]}>
                  <img
                    src={`${imagePrefix}/assets/images/custom-arrow.svg`}
                    style={{ marginBottom: ".125rem" }}
                  />
                </span>
              ) : (
                ""
              )}
            </a>
          </Link>
        </>
      );
    } else if (props.navigation) {
      return (
        <>
          <a
            id={props.id}
            href={props.navigation}
            onClick={props.handleClick}
            className={`${styles["button"]} ${
              styles[`button__${setButtonStyle}`]
            } ${props.className}`}
          >
            {props.children}
          </a>
        </>
      );
    } else {
      return (
        <button
          type={props.type}
          id={props.id}
          value={props.value}
          className={`${styles["button"]} ${
            styles[`button__${setButtonStyle}`]
          } ${props.className}  ${styles[props?.btnSizing]}`}
          disabled={props.disabled}
          onClick={props.handleClick}
        >
          {" "}
          {props.children}
          {props.variant.includes("link") ? (
            <span className={styles["right-arrow"]}>
              <img
                src={generateImageUrl()}
                style={{ marginBottom: ".125rem" }}
              />
            </span>
          ) : (
            ""
          )}
        </button>
      );
    }
  };
  return renderButtonContents();
};

CTAButton.defaultProps = {
  type: "button",
  id: "",
  className: "",
  variant: "",
  children: "",
  disabled: false,
  url: "",
  handleClick: () => {},
};

CTAButton.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  value: PropTypes.string,
  url: PropTypes.string,
};
export default CTAButton;
